module.exports = __webpack_public_path__ + "img/m_award_img02.d1ff167e.jpg";